import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'https://api-invoice.ainixit.com/api';

const initialState = {
  subscription: null,
  isLoading: false,
  error: null,
};

// Get auth config
const getAuthConfig = (getState) => {
  const { token } = getState().auth;
  return {
    headers: { Authorization: `Bearer ${token}` },
  };
};

// Get user subscription
export const getMySubscription = createAsyncThunk(
  'subscription/getMySubscription',
  async (_, { rejectWithValue, getState }) => {
    try {
      const response = await axios.get(`${API_URL}/subscriptions/my-subscription`, getAuthConfig(getState));
      return response.data.subscription;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch subscription');
    }
  }
);

// Create checkout session
export const createCheckoutSession = createAsyncThunk(
  'subscription/createCheckoutSession',
  async (planId, { rejectWithValue, getState }) => {
    try {
      const response = await axios.post(
        `${API_URL}/subscriptions/checkout`,
        { planId },
        getAuthConfig(getState)
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to create checkout session');
    }
  }
);

// Cancel subscription
export const cancelSubscription = createAsyncThunk(
  'subscription/cancelSubscription',
  async (_, { rejectWithValue, getState }) => {
    try {
      const response = await axios.post(`${API_URL}/subscriptions/cancel`, {}, getAuthConfig(getState));
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to cancel subscription');
    }
  }
);

const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMySubscription.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getMySubscription.fulfilled, (state, action) => {
        state.isLoading = false;
        state.subscription = action.payload;
      })
      .addCase(getMySubscription.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(createCheckoutSession.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createCheckoutSession.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(createCheckoutSession.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default subscriptionSlice.reducer;

